import React, { forwardRef } from 'react'
import ObrysIkony from './ObrysIkony'

/**
 * PROPOZYCJA, jeszcze nigdzie nie użyta: ikona katalogu „Ładowarki” zamiast PowerIcon.
 *
 * Symbol zasilania (kółko z kreską) czyta się jak „włącz / wyłącz”, a nie jak ładowarka do auta.
 * Tu jest skrzynka wallboxa z błyskawicą i przewód zakończony wtyczką. Żeby jej użyć, wystarczy
 * podmienić `Icon` przy „Ładowarkach” w config/nawigacja.js.
 */
const IkonaLadowarki = forwardRef((props, ref) => (
  <ObrysIkony ref={ref} {...props}>
    <path d='M6 3h6a1.5 1.5 0 0 1 1.5 1.5v12A1.5 1.5 0 0 1 12 18H6a1.5 1.5 0 0 1-1.5-1.5v-12A1.5 1.5 0 0 1 6 3Z' />
    <path d='m9.75 6.75-1.875 3.75h2.25L8.25 14.25' />
    <path d='M13.5 12H15a2.25 2.25 0 0 1 2.25 2.25V18' />
    <path d='M16.125 18h2.25v1.5a1.125 1.125 0 0 1-2.25 0Z' />
  </ObrysIkony>
))

export default IkonaLadowarki
